module.exports = __webpack_public_path__ + "img/bike_card_7_content_bg.40911226.png";